import {create} from 'zustand';

interface UtilsState {
    searchTerm: string;
    setSearchTerm: (searchTerm: string) => void;
}

export const useUtilsStore = create<UtilsState>((set) => ({
    searchTerm: '',
    setSearchTerm: (searchTerm) => set({searchTerm})
}))